import React from 'react';
import Reveal from './Reveal';
import programs, { BELL_RULE_LABEL } from '../data/programs';

/**
 * The catalogue's three programs (data/programs.js mirrors the app's, and a
 * test holds it there). The bar has one cell per week of the program.
 */
const Programs = () => (
  <section id="programs" className="section section-deep" aria-labelledby="programs-headline">
    <div className="section-inner">
      <Reveal>
        <p className="eyebrow">Programs</p>
        <h2 id="programs-headline" className="h2 h2-narrow">
          A simple plan, written for a kettlebell.
        </h2>
        <div className="grid-3">
          {programs.map((p) => (
            <article key={p.id} className="card program">
              <div className="program-top">
                <span className={`tag ${p.tier === 'free' ? 'tag-free' : 'tag-pro'}`}>
                  {p.tier === 'free' ? 'Free' : 'Pro'}
                </span>
                <span className="program-length">
                  {p.weeks} weeks · {BELL_RULE_LABEL[p.equipmentRule]}
                </span>
              </div>
              <h3 className="h3">{p.name}</h3>
              <div
                className="weeks"
                style={{ gridTemplateColumns: `repeat(${p.weeks}, 1fr)` }}
                aria-hidden="true"
              >
                {Array.from({ length: p.weeks }, (_, i) => (
                  <span key={i} />
                ))}
              </div>
              <p>{p.summary}</p>
            </article>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default Programs;
